import type {
  AssistantConversationItemModelData,
  AssistantConversationModelData,
  AssistantNoteActivityModelData,
  AssistantNoteReviewStatusModelData,
  AssistantObjectiveModelData,
  AssistantProjectActivityModelData,
  AssistantProjectLabelAssignmentModelData,
  AssistantProjectLabelGroupModelData,
  AssistantProjectLabelModelData,
  AssistantSpaceAccountSettingsModelData,
  AssistantTaskActivityModelData,
  AssistantTaskLabelAssignmentModelData,
  AssistantTaskNoteReferenceModelData,
  AssistantTaskLabelGroupModelData,
  AssistantTaskLabelModelData,
} from "@/store/assistant/types";

type AssistantIndexBaseModelData = {
  assistant_id: string;
  created_at: string;
  updated_at: string;
};

const commonAssistantIndexes = (modelData: AssistantIndexBaseModelData | undefined) => ({
  assistant_id: modelData?.assistant_id ?? "",
  created_at: modelData?.created_at ?? "",
  updated_at: modelData?.updated_at ?? "",
});

export const assistantSyncModelIndexers = {
  taskLabelGroup: (modelData: AssistantTaskLabelGroupModelData | undefined) => ({
    ...commonAssistantIndexes(modelData),
    name: modelData?.name ?? "",
  }),
  taskLabel: (modelData: AssistantTaskLabelModelData | undefined) => ({
    ...commonAssistantIndexes(modelData),
    group_id: modelData?.group_id ?? "",
    name: modelData?.name ?? "",
  }),
  taskLabelAssignment: (modelData: AssistantTaskLabelAssignmentModelData | undefined) => ({
    ...commonAssistantIndexes(modelData),
    task_label_id: modelData?.task_label_id ?? "",
    task_id: modelData?.task_id ?? "",
  }),
  taskNoteReference: (modelData: AssistantTaskNoteReferenceModelData | undefined) => ({
    ...commonAssistantIndexes(modelData),
    task_id: modelData?.task_id ?? "",
    note_id: modelData?.note_id ?? "",
  }),
  projectLabelGroup: (modelData: AssistantProjectLabelGroupModelData | undefined) => ({
    ...commonAssistantIndexes(modelData),
    name: modelData?.name ?? "",
  }),
  projectLabel: (modelData: AssistantProjectLabelModelData | undefined) => ({
    ...commonAssistantIndexes(modelData),
    group_id: modelData?.group_id ?? "",
    name: modelData?.name ?? "",
  }),
  projectLabelAssignment: (modelData: AssistantProjectLabelAssignmentModelData | undefined) => ({
    ...commonAssistantIndexes(modelData),
    project_label_id: modelData?.project_label_id ?? "",
    project_id: modelData?.project_id ?? "",
  }),
  taskActivity: (modelData: AssistantTaskActivityModelData | undefined) => ({
    ...commonAssistantIndexes(modelData),
    task_id: modelData?.task_id ?? "",
    kind: modelData?.kind ?? "",
  }),
  projectActivity: (modelData: AssistantProjectActivityModelData | undefined) => ({
    ...commonAssistantIndexes(modelData),
    project_id: modelData?.project_id ?? "",
    kind: modelData?.kind ?? "",
  }),
  noteActivity: (modelData: AssistantNoteActivityModelData | undefined) => ({
    ...commonAssistantIndexes(modelData),
    note_id: modelData?.note_id ?? "",
    kind: modelData?.kind ?? "",
  }),
  objective: (modelData: AssistantObjectiveModelData | undefined) => ({
    ...commonAssistantIndexes(modelData),
    scope_kind: modelData?.scope_kind ?? "",
    scope_key: modelData?.scope_key ?? "",
    key: modelData?.key ?? "",
    status: modelData?.status ?? "",
    priority: modelData?.priority ?? "",
  }),
  noteReviewStatus: (modelData: AssistantNoteReviewStatusModelData | undefined) => ({
    ...commonAssistantIndexes(modelData),
    note_id: modelData?.note_id ?? "",
    reviewed_at: modelData?.reviewed_at ?? "",
  }),
  spaceAccountSettings: (modelData: AssistantSpaceAccountSettingsModelData | undefined) => ({
    ...commonAssistantIndexes(modelData),
    space_account_id: modelData?.space_account_id ?? "",
  }),
  conversation: (modelData: AssistantConversationModelData | undefined) => ({
    ...commonAssistantIndexes(modelData),
    last_activity_at: modelData?.last_activity_at ?? "",
    created_via: modelData?.created_via ?? "",
    archived_at: modelData?.archived_at ?? "",
  }),
  conversationItem: (modelData: AssistantConversationItemModelData | undefined) => ({
    ...commonAssistantIndexes(modelData),
    conversation_id: modelData?.conversation_id ?? "",
    sequence: modelData?.sequence ?? -1,
    kind: modelData?.kind ?? "",
    mem_agent_run_id: modelData?.mem_agent_run_id ?? "",
  }),
};
